import React, { useEffect, useState } from "react";
import axios from "axios";
import Super_admin_navbar from "./Super_admin_navbar";

import toast, { Toaster } from "react-hot-toast";

const notify = (msg) => toast.success(msg);
const notifyError = (msg) => toast.error(msg);
const notifyMessage = (msg) =>
  toast(msg, {
    duration: 10000,
  });

function Super_admin({ url }) {
  const [username, setusernames] = useState("");
  const [password, setpasswords] = useState("");
  const [token, setToken] = useState("");
  const [protectedData, setProtectedData] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${url}/login_admin`, {
        username: username,
        password: password,
      });
      const data = response.data;
      localStorage.setItem("admin_login", JSON.stringify(data));
      notify("Admin login successful");
      window.location.href = `/admin`;

      console.log("Token:", data);
    } catch (error) {
      notifyError("Wrong Username or Password");
      console.error("Error:", error.response.data.message);
    }
  };

  return (
    <div>
      {" "}
      <form onSubmit={handleSubmit} className="m-t-7">
        <div className="container-kws">
          <div className="m-y-3 f-s-2 t-a-c f-w-600">Admin Login</div>
          <div className="row m-y-1">
            <div className="col-4 f-s-1_25 f-w-600">Username</div>
            <div className="col-8">
              <input
                type="text"
                className="w-100 b-1 b-r-5 pa-0_5"
                placeholder="enter username ...."
                value={username}
                onChange={(e) => setusernames(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4 f-s-1_25 f-w-600">Password</div>
            <div className="col-8">
              <input
                type="password"
                className="w-100 b-1 b-r-5 pa-0_5"
                placeholder="enter password ...."
                value={password}
                onChange={(e) => setpasswords(e.target.value)}
              />
            </div>
          </div>
          <div className=" t-a-c m-t-3">
            <button
              className="f-w-600 f-s-1_5 b-c-t c-w b-1 b-r-20 p-x-3 p-y-0_5"
              type="submit"
            >
              Submit
            </button>
          </div>
        </div>{" "}
      </form>
      <Toaster position="top-center" reverseOrder={true} />
    </div>
  );
}

export default Super_admin;
